import { render } from "./Maintenance.vue?vue&type=template&id=633df78f&scoped=true"
const script = {}

import "./Maintenance.vue?vue&type=style&index=0&id=633df78f&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633df78f"]])

export default __exports__